import n from "./td-longtail-vue-components135.js";
/* empty css                              */
import s from "./td-longtail-vue-components98.js";
var i = function() {
  var e = this, r = e._self._c, a = e._self._setupProxy;
  return r(a.InputWrapper, e._b({ staticClass: "radio-input", attrs: { large: !1, medium: !1, "show-label": "", "inline-label": !1 }, scopedSlots: e._u([{ key: "label", fn: function({ id: t }) {
    return [r("input", { staticClass: "radio-input__input", attrs: { id: t, type: "radio", name: e.name, "aria-invalid": !!e.errorMessage, "aria-describedby": `${t}-error`, required: e.required, disabled: e.disabled }, domProps: { value: e.val, checked: e.val === e.value }, on: { change: a.onChange } }), r("span", { staticClass: "radio-input__icon" }), r("div", [e._t("default", function() {
      return [e._v(" " + e._s(e.label) + " ")];
    }), e.required ? r("span", { staticClass: "input-wrapper__required" }, [e._v("*")]) : e._e()], 2)];
  } }], null, !0) }, "InputWrapper", a.inputWrapperProps, !1));
}, l = [], o = /* @__PURE__ */ s(
  n,
  i,
  l,
  !1,
  null,
  "4d2205dc"
);
const c = o.exports;
export {
  c as default
};
